import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const ZamenCheques_endpoints = APIS_ENDPOINTS.requestzamencheques

export interface IZamenChequesCountPayload {
  id?: number
  amount: number
  date: string
  requestId: number,
  chequesType: number;
}
export const request_sendzamenchequescount = async (data: IZamenChequesCountPayload) => {
  return http.post(ZamenCheques_endpoints.sendzamencheques, data)
}

export const request_getallrequestzamencheques = async ({
  RequestId,
}: {
  RequestId: number
}) => {
  return http.get(
    ZamenCheques_endpoints.getallrequestzamencheques + '?RequestId=' + RequestId
  )
}

export const request_delete= async ({
  id,
}: {
  id: number
}) => {
  return http.delete(
    ZamenCheques_endpoints.delete + '?id=' + id
  )
}